<template>
  <div>
  <router-view />
  </div>
</template>


<script>
import { useStore } from 'vuex';
import { loadCompagnie } from "@/lib/flightutils";
import { getQueryStringParams } from "@/lib/parametri";
import { getAeroporti } from "@/lib/flightutils";
//import { useReCaptcha } from 'vue-recaptcha-v3';

export default {
  name: 'App',
  components: {

  },
  setup(){
    const store = useStore();
   // const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

   /* const recaptcha = async () => {
      await recaptchaLoaded()
      const token = await executeRecaptcha('login')
      store.state.compilazione.recaptcha_token = token;
    }*/

    return {
      //recaptcha,
      impostaCompagnie: (compagnie)=>{
        store.dispatch('volo/commitSetCompagnie',compagnie);
      },
      setDestinazione : (destinazione)=>{
        store.dispatch('volo/commitSetDestinazione',destinazione);
      },
      setPartenza : (partenza)=>{
        store.dispatch('volo/commitSetPartenza',partenza);
      },
      setTokenCampagna : (token)=>{
        store.dispatch('compilazione/commitSetTokenCampagna',token);
      },
      setUtmSource: (id) => {
        store.dispatch('compilazione/commitSetUtmSource',id);
      },
      setUtmMedium: (id) => {
        store.dispatch('compilazione/commitSetUtmMedium',id);
      },
      setUtmCampaign: (id) => {
        store.dispatch('compilazione/commitSetUtmCampaign',id);
      },
      setPartnerCode: (id) => {
        store.dispatch('compilazione/commitSetPartnerCode',id);
      },
      setPartnerCodeReadOnly: (value) =>{
        store.dispatch('compilazione/commitSetPartnerCodeReadOnly',value);
      },
      elaboraEventiPersonalizzatiSuQueryString(params){
        if(params.get("utm_source") == null) return;
        let source = params.get("utm_source");
        let medium = params.get("utm_medium");
        let campaign = params.get("utm_campaign");
        this.$gtm.trackEvent({
          event: 'infocampagna',
          value: "source="+source+":medium="+medium+":campaign="+campaign,
        });

        if(source == "piratiinviaggio") {
          this.$gtm.trackEvent({
            event: 'piratihit',
            value: "source="+source+":medium="+medium+":campaign="+campaign,
          });
        }

      }


    }
  },
  data(){
    return {

    }
  },
  created(){

  },
  mounted(){

   // this.inizializzaCompagnie();
    this.verificaDatiPrecompilati();
    //this.recaptcha();
  },
  methods:{
    /***
     * carica la lista iniziale delle compagnie
     */
    inizializzaCompagnie:function(){
      let vm = this;
      loadCompagnie().then((compagnie)=>{
        vm.impostaCompagnie(compagnie);

      }).catch((err)=>{
          console.log(err);
      });
    },
    /***
     * imposta i valori di compilazione in base ai parametri in query string (aeroporti,campagne,partners...)
     */
    verificaDatiPrecompilati: function(){
      let params = getQueryStringParams();
      let partenzaid = params.get('aeropuid');
      let destinazioneid = params.get('aeroduid');
      if(partenzaid !== null || destinazioneid !== null) {
          getAeroporti(partenzaid,destinazioneid).then((res)=>{
              if(res.destinazione !== null) { this.setDestinazione(res.destinazione); }
              if(res.partenza !== null) { this.setPartenza(res.partenza); }
          });
      }

      this.setTokenCampagna(params.get("cmptk"));
      this.setUtmSource(params.get("utm_source"));
      this.setUtmMedium(params.get("utm_medium"));
      this.setUtmCampaign(params.get("utm_campaign"));
      this.setPartnerCode(params.get("prtn"));
      if(params.get("prtn") !== null && params.get("prtn") !== '') { this.setPartnerCodeReadOnly(true); }
      this.elaboraEventiPersonalizzatiSuQueryString(params);

    },
    primo(){
      this.$router.push('/');
    },
    secondo(){
      this.$router.push('/volo');
    },
    terzo(){
      this.$router.push('/infopersonali')
    },
    quarto(){
      this.$router.push('/conferma')
    },
    quinto(){
      this.$router.push('/conclusione')
    }
  }
}
</script>


